<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-03-31 16:49:13
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-04-08 18:20:32
 * @FilePath: /dsicm-admin-web/src/views/questionnaire/components/index.vue
-->
<template>
    <div class="page-wrapper">
        <el-dialog 
        width="400px"
        top="5vh"
        :paramData="paramData"
        :close-on-click-modal="false"
        @close="closeModal"
        center
        :visible.sync="previewVisible">
        <template slot="title">
            <div class="title-view">
                <h1 >{{paramData.title}}</h1>
                <h2>{{paramData.subTitle}} </h2>
                <h3>{{paramData.name}} </h3>
            </div>
        </template>
        <div style="height:550px" class="scroll-bar-view">
            <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;" >
                <div v-for="(item,index) in questionAnswers" :key="index">
                    <h1>{{index*1+1}}.{{item.title}}</h1>
                    <el-radio-group v-model="item.radio" v-if="!item.type">
                        <el-radio 
                            v-for="(sub,subIndex) in item.answers" 
                            :key="subIndex"
                            :label="sub.id">
                            {{sub.answer}}
                            <div style="margin-top:20px" v-show="item.radio == sub.id && sub.isRemark" >
                                <el-row>
                                    <el-col :span="16">
                                        <el-input size="mini" v-model="item.remark" placeholder="请填写" class="col-input"></el-input>
                                    </el-col>
                                    <el-col class="row-col" v-show="sub.remark">
                                        *{{sub.remark}}
                                    </el-col>
                                </el-row>
                            </div>
                        </el-radio>
                    </el-radio-group>
                    <el-row>
                        <el-col :span="16">
                            <el-input v-if="item.type" size="mini" v-model="item.redio" placeholder="请填写" class="col-input" style="margin-bottom:25px"></el-input>
                        </el-col>
                    </el-row>
                </div>
            </el-scrollbar>
        </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name:'previewDialog',
    props:{
        paramData:{
            type:Object,
            default: () => {}
        }
    },
    data(){
        return{
            previewVisible:false,//弹窗开关
            questionAnswers:[],//数据展示
        }
    },
    watch:{
        paramData(newVal,oldval){
            this.questionAnswers = newVal.questionAnswers
        }
    },
    methods:{
        /**
         * @description: 关闭弹窗后的回调
         * @param {*}
         * @return {*}
         */    
        closeModal(){
            
        },
        /**
         * @description: 弹窗开关
         * @param {*}
         * @return {*}
         */    
        showVisible(){
            this.previewVisible = !this.previewVisible;
        },
    }
}
</script>

<style lang="less" scoped>

.el-dialog__header .title-view{
    h1{
        font-size: 20px;
    }
     h2{
        font-size: 14px;
    }
     h3{
        font-size: 12px;
        color: #DCDFE6;
    }
}
.scroll-bar-view{
    h1{
        font-weight: 600;
        margin-bottom: 20px;
    }
    .el-radio-group{
        display: flex;
        flex-direction: column;
    .el-radio{
        margin-bottom: 25px;
        .row-col{
            color: #ee1414;
            font-size: 12px;
            margin-top: 10px;
        }
    }
}
}

</style>